module.exports = __webpack_public_path__ + "img/nav-after.a276a09d.svg";